import { DateRangePickerNative, IconButton, Popover, Portal } from '@lego/klik-ui';
import { Filter, FilterBold } from '@lego/klik-ui/icons';
import type { RowData } from '@tanstack/react-table';
import type { Column } from '../appTable';

export const DatePickerRangeFilter = <T extends RowData>({ column }: { column: Column<T> }) => {
  const parseSelectedValues = (selectedValues: { from?: string; to?: string }) => {
    const from = selectedValues.from ? selectedValues.from.split('T')[0] : '';
    const to = selectedValues.to ? selectedValues.to.split('T')[0] : '';
    return [from, to];
  };

  const parseDateArray = (dateArray: string[]) => {
    const from = dateArray[0] !== '' ? new Date(dateArray[0]).toISOString() : undefined;
    const to = dateArray[1] !== '' ? new Date(dateArray[1]).toISOString() : undefined;
    return { from, to };
  };

  const filterValue = (column.getFilterValue() || {}) as { from?: string; to?: string };

  return (
    <Popover autoFocus closeOnBlur isLazy placement="top-end">
      <Popover.Trigger>
        {!filterValue?.from && !filterValue?.to ? (
          <IconButton aria-label="Menu" icon={<Filter />} size="xs" variant="ghost" />
        ) : (
          <IconButton aria-label="Menu" icon={<FilterBold />} size="xs" variant="ghost" />
        )}
      </Popover.Trigger>
      <Portal>
        <Popover.Content>
          <DateRangePickerNative
            onChange={(dateArray) => column.setFilterValue(parseDateArray(dateArray))}
            value={parseSelectedValues(filterValue)}
          >
            <DateRangePickerNative.DatePicker label="From" />
            <DateRangePickerNative.DatePicker label="To" />
          </DateRangePickerNative>
        </Popover.Content>
      </Portal>
    </Popover>
  );
};
